import React from 'react';
import {Typography} from '@mui/material';
import s from './BookingDetailsPage.module.scss';
import {FIELD_LABEL_TRANSLATIONS} from '../../assets/translations/translations'; // import translation map

const ParticipantDetailsStep = ({
                                    product,
                                    formData,
                                    updateField,
                                    validationErrors,
                                    pickupList,
                                    pickupLoading,
                                    pickupError
                                }) => {
    const translateLabel = (label) => FIELD_LABEL_TRANSLATIONS[label] || label;
    console.log(product.bookingFields)
    const FIELD_ORDER = [
        'First Name',
        'Last Name',
        'Email',
        'Phone',
        'Special Requirements'
    ];

    const sortFields = (fields) => {
        return [...fields].sort((a, b) => {
            const indexA = FIELD_ORDER.indexOf(a.label);
            const indexB = FIELD_ORDER.indexOf(b.label);

            const rankA = indexA === -1 ? 999 : indexA;
            const rankB = indexB === -1 ? 999 : indexB;

            return rankA - rankB;
        });
    };
    return (
        <>
            {/* Pickup */}
            {product?.pickupId && product.pickupId !== 0 && (
                <div className="card mb-3">
                    <h5 className="card-header">
                        ピックアップ場所
                    </h5>
                    <div className="card-body">
                        {pickupLoading ? (

                            <div className="d-flex justify-content-center py-4">
                                Loading...
                            </div>

                        ) : pickupError ? (

                            <p className={s.errorText}>
                                {pickupError}
                            </p>

                        ) : pickupList.length > 0 ? (

                            <div className={s.field}>

                                <label className={s.field__label}>
                                    ピックアップ場所
                                    <span className={s.required}>*</span>
                                </label>

                                <select
                                    value={formData.pickup}
                                    onChange={(e) =>
                                        updateField('pickup', e.target.value)
                                    }
                                    className={s.select}
                                >
                                    <option value="">
                                        ピックアップ場所を選択してください
                                    </option>

                                    {pickupList.map((pickup, index) => (
                                        <option
                                            key={pickup.pickupId || index}
                                            value={
                                                pickup.locationName ||
                                                pickup.name ||
                                                ''
                                            }
                                        >
                                            {pickup.locationName ||
                                                pickup.name ||
                                                `Pickup ${index + 1}`}

                                            {pickup.minutesPrior &&
                                                ` (${pickup.minutesPrior}分前)`}
                                        </option>
                                    ))}
                                </select>
                                {validationErrors?.pickup && (
                                    <p className={s.errorText}>
                                        {validationErrors.pickup}
                                    </p>
                                )}
                            </div>

                        ) : (

                            <p className={s.emptyText}>
                                ピックアップオプションがありません。
                            </p>

                        )}

                    </div>
                </div>
                // <div className={s.section}>
                //
                //
                //
                //
                // </div>
            )}
            {/* Per-booking fields */}
            <div className="card mb-3">
                <h5 className="card-header">
                    その他の詳細
                </h5>
                <div className="card-body">
                    {sortFields(
                        product.bookingFields?.filter(f => f.visiblePerBooking || f.requiredPerBooking) || []
                    ).map(field => (
                        <div key={field.label} className={s.field}>
                            <label className={s.field__label}>
                                {translateLabel(field.label)} {field.requiredPerBooking &&
                                <span className={s.required}>*</span>}
                            </label>
                            {field.fieldType === 'Boolean' ? (
                                <select
                                    value={formData.bookingFields[field.label] ?? ''}
                                    onChange={e =>
                                        updateField(
                                            `bookingFields.${field.label}`,
                                            e.target.value
                                        )
                                    }
                                    className={s.select}
                                >
                                    <option value="">選択してください</option>
                                    <option value="1">Yes</option>
                                    <option value="0">No</option>
                                </select>
                            ) : field.fieldType === 'List' ? (
                                <select
                                    value={formData.bookingFields[field.label] || ''}
                                    onChange={e => updateField(`bookingFields.${field.label}`, e.target.value)}
                                    className={s.select}
                                >
                                    <option value="">選択してください</option>
                                    {(field.listOptions || '')
                                        .split(/\r?\n/)
                                        .filter(opt => opt.trim() !== '')
                                        .map((opt, index) => (
                                            <option key={index} value={opt.trim()}>
                                                {opt.trim()}
                                            </option>
                                        ))}
                                </select>
                            ) : (
                                <input
                                    value={formData.bookingFields[field.label] || ''}
                                    onChange={e => updateField(`bookingFields.${field.label}`, e.target.value)}
                                    placeholder={translateLabel(field.label)}
                                />
                            )}
                            {validationErrors[`booking_${field.label}`] && (
                                <p className={s.errorText}>{validationErrors[`booking_${field.label}`]}</p>
                            )}
                        </div>
                    ))}
                </div>
            </div>
            {/* Per-participant fields */}
            {product.bookingFields?.some(f => f.visiblePerParticipant || f.requiredPerParticipant) && (
                <div className="card">
                    <h5 className="card-header">
                        参加者詳細
                    </h5>
                    <div className="card-body">
                        <Typography variant="h6" className={s.section__title}>
                            参加者詳細（1人ごと）
                        </Typography>
                        {formData.participants.map((_, idx) => (
                            <div key={idx} className={s.participantCard}>
                                <Typography variant="subtitle1" className="font-bold mb-4">
                                    参加者 {idx + 1}
                                </Typography>
                                {product.bookingFields
                                    ?.filter(f => f.visiblePerParticipant || f.requiredPerParticipant)
                                    .map(field => (
                                        <div key={field.label} className={s.field}>
                                            <label className={s.field__label}>
                                                {translateLabel(field.label)} {field.requiredPerParticipant &&
                                                <span className={s.required}>*</span>}
                                            </label>
                                            {field.fieldType === 'List' ? (
                                                <select
                                                    value={formData.participants[idx][field.label] || ''}
                                                    onChange={e => updateField(`participants.${idx}.${field.label}`, e.target.value)}
                                                    className={s.select}
                                                >
                                                    <option value="">選択してください</option>
                                                    {(field.listOptions || '')
                                                        .split(/\r?\n/)
                                                        .filter(opt => opt.trim() !== '')
                                                        .map((opt, index) => (
                                                            <option key={index} value={opt.trim()}>
                                                                {opt.trim()}
                                                            </option>
                                                        ))}
                                                </select>
                                            ) : (
                                                <input
                                                    value={formData.participants[idx][field.label] || ''}
                                                    onChange={e => updateField(`participants.${idx}.${field.label}`, e.target.value)}
                                                    className={s.select}
                                                    placeholder={translateLabel(field.label)}
                                                />
                                            )}
                                        </div>
                                    ))}
                            </div>
                        ))}
                    </div>
                </div>
            )}
        </>
    );
};

export default ParticipantDetailsStep;